import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../services/auth/auth.service';
import { decodeJwtToken } from '../../../shared/utils/jwt.util';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-process-token',
  imports: [],
  templateUrl: './process-token.component.html',
  styleUrl: './process-token.component.scss',
})
export class ProcessTokenComponent implements OnInit {
  redirectUrl: string | null = null;

  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);
  private readonly authService = inject(AuthService);

  constructor() {
    this.route.queryParamMap.subscribe((params) => {
      this.redirectUrl = params.get('redirect-url');
    });
  }
  ngOnInit(): void {
    this.loginProcessing();
  }

  loginProcessing() {
    const refreshToken = localStorage.getItem(environment.refreshToken);
    if (!refreshToken) {
      void this.router.navigateByUrl('/');
      return;
    }
    this.authService
      .generateAccessToken(JSON.parse(refreshToken as string))
      .subscribe({
        next: (data) => {
          const redirectUrl = this.redirectUrl ?? '';

          // Check if redirecting to admin application and user is not admin
          if (
            this.isAdminApplication(redirectUrl) &&
            !this.isUserAdmin(data.idToken)
          ) {
            // Show error and redirect to login instead of admin app
            alert(
              'Access denied. Admin privileges required to access this application.',
            );
            void this.router.navigateByUrl('/');
            return;
          }

          window.location.href = `${redirectUrl}?${environment.refreshToken}=${data.idToken}`;
        },
        error: (_err) => {
          this.authService.initiateLogout(this.redirectUrl);
        },
      });
  }

  /**
   * Checks if the redirect URL is for an admin application
   */
  private isAdminApplication(redirectUrl: string): boolean {
    return redirectUrl.includes('/admin') || redirectUrl.includes('admin.');
  }

  /**
   * Checks if the user has admin privileges based on the JWT token
   */
  private isUserAdmin(token: string): boolean {
    const decodedToken = decodeJwtToken(token);
    return decodedToken?.bIsAdmin === true;
  }
}
